import EventEmitter from "./Events.utils";

class ErrorUtils {
    showError = (text) => {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: text, type: 'error'});
    }

    showSuccess = (text) => {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: text, type: 'success'});
    }

    showGeneric = (text, type) => {
        EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: text, type: type});
    }
};

export default new ErrorUtils();
